import { Button } from "@devhop/ui";
import { DownloadIcon, HelpCircleIcon, UploadIcon } from "lucide-react";

type StockToolbarProps = {
  canManage: boolean;
  onAdjustStock: () => void;
  onSettings?: () => void;
  onStartTour?: () => void;
  onExportTemplate?: () => void | Promise<void>;
  onImportCsv?: () => void;
  /** ມີຂໍ້ມູນຕາມຕົວກອງ (ຫຼືຈະສົ່ງອອກໄດ້) */
  canExportTemplate?: boolean;
  exportTemplateLoading?: boolean;
};

export function StockToolbar({
  canManage,
  onAdjustStock: _onAdjustStock,
  onSettings: _onSettings,
  onStartTour,
  onExportTemplate,
  onImportCsv,
  canExportTemplate = false,
  exportTemplateLoading = false,
}: StockToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="flex items-center font-bold text-2xl tracking-tight">
            ສະຕ໋ອກ{" "}
            {onStartTour && (
              <Button
                variant="ghost"
                size="icon"
                onClick={onStartTour}
                className="ml-2 size-6"
                title="ເລີ່ມທົດລອງການນຳທາງ"
              >
                <HelpCircleIcon className="h-4 w-4" />
              </Button>
            )}
          </h2>
          <p className="text-muted-foreground">
            ຈັດການສະຕ໋ອກສິນຄ້າ, ຕັດສະຕ໋ອກ, ແລະຕິດຕາມການເຄື່ອນໄຫວ
          </p>
        </div>
        {canManage && (onExportTemplate || onImportCsv) && (
          <div
            className="flex items-center gap-2"
            data-tourid="inventory-stock-toolbar"
          >
            {onExportTemplate && (
              <Button
                variant="outline"
                onClick={() => void onExportTemplate()}
                disabled={!canExportTemplate || exportTemplateLoading}
                title={
                  canExportTemplate
                    ? undefined
                    : "ບໍ່ມີຂໍ້ມູນຕາມຕົວກອງ"
                }
              >
                <DownloadIcon className="h-4 w-4" />
                {exportTemplateLoading ? "ກຳລັງສົ່ງອອກ..." : "ສົ່ງອອກ template"}
              </Button>
            )}
            {onImportCsv && (
              <Button variant="outline" onClick={onImportCsv}>
                <UploadIcon className="h-4 w-4" />
                ນຳເຂົ້າ CSV
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
